import React from 'react';
import { Overview } from 'src/features/DA/components/templates/Overview';
import { PageModelLayout } from '../../components/molecules/PageModelLayout';
import { DAKeyMetrics } from '../../features/DA/components/organisms/DAKeyMetrics';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const OverviewPage: React.FC = () => {
  return (
    <PageModelLayout
      filterBar={<FilterBar includeBenchmark />}
      pageTitle="Overview"
      keyMetrics={<DAKeyMetrics />}
      extraButtons={<GenAIActionButtons />}
      // genAiInsights={IS_DEV ? <GenAIInsights /> : null}
    >
      <Overview />
    </PageModelLayout>
  );
};
